<template>
  <div class="emailmain">
        <div class="horizFlex">
            <div class="framed">
                <sendmessageframe ref="sendmessage" />
            </div>

        </div>
        <div class="horizFlex">
                
            <messagetemplate @refresh="getTemplates()"/>

        </div>

  </div>
</template>

<script>
import messagetemplate from './messageTemplate.vue'
import sendmessageframe from './sendmessageframe.vue'
import {mapFields} from 'vuex-map-fields'
import datamethods from '../../datamethods.js'
export default {
    name:'emailmessages',
    components:{
      messagetemplate,
      sendmessageframe
    },
    props:{
       
    },
    mixins:[datamethods],
    data(){
        return{
            pleaseWaitText:'Please wait...',
            pleaseWait:false,
            message:'',
         
        }
    },
    
    computed:{
         ...mapFields([
            'messageTemplateList',
           'locationList'
            

        ]),
        
    },
    methods:{
       async getTemplates(){
            var response = await this.callAPI(null,'templates')
            if(response.Successful){

                this.messageTemplateList=response.MessageTemplateList

            }else{
                //this.message = response.Message
               // this.handleAuthResponse()
            }
        },
        async getLocations(){
            
            //call api
            var response = await this.callAPI(null,'locationswithall')
            //handle response
            if(response.Successful){
                this.locationList=response.locationList
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },
    
    },
    mounted(){
        this.getLocations()
        this.getTemplates()
    }
}
</script>

<style>

.emailmain{
    display:flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    
}

</style>

